// Separate RC Developer Console app ("Click to Call"), NOT the same Client ID as TextMyCustomer
// (the app the SMS automation / rc_jwt-based server-side calls run through). Deliberately split
// so this app can run pure Authorization Code + PKCE (no JWT, no client secret, no shared-secret
// exposure to the browser) without touching TextMyCustomer's JWT-flow setting, which the rest of
// the app's automation depends on. Configured for exactly 3 scopes: VoIP Calling, WebSocket,
// Read Presence -- see CLAUDE.md, Click-to-Call section.
const RC_CLIENT_ID = 'VqaDpHWUvooesCWuhBHW4m';

let loadAttempted = false;

// Mounts the RingCentral Embeddable widget once per browser session, using RC's recommended
// Authorization Code + PKCE flow -- no JWT or client secret ever reaches the browser, and no
// network round-trip to our own backend either. The first time a recruiter opens the widget,
// RC shows its own login popup (their real RC username/password, one time); after that RC's
// own SDK manages the access/refresh token in this browser's storage, entirely independent of
// the rc_jwt column used server-side for SMS automation. Deliberately synchronous and
// dependency-free -- this runs from SharedNav, which mounts on every internal page, so the
// less that can go wrong here, the better.
export function ensureRcWidgetLoaded() {
  if (loadAttempted) return;
  loadAttempted = true;
  try {
    const script = document.createElement('script');
    script.src = `https://apps.ringcentral.com/integration/ringcentral-embeddable/latest/adapter.js?clientId=${encodeURIComponent(RC_CLIENT_ID)}`;
    document.body.appendChild(script);
  } catch (err) {
    console.error('[rcWidget] failed to load widget:', err.message);
  }
}

// Triggers a call through the already-mounted widget. window.RCAdapter is the global the adapter
// script exposes once loaded -- see https://ringcentral.github.io/ringcentral-embeddable/docs/integration/click-to-dial/
// No-op (not a throw) if the widget isn't loaded/logged-in yet, since every call site here is a
// plain button click, not a flow that should crash the page.
export function callNumber(phoneNumber) {
  if (!phoneNumber) return;
  try {
    if (window.RCAdapter && typeof window.RCAdapter.clickToCall === 'function') {
      window.RCAdapter.clickToCall(phoneNumber, true);
    } else {
      console.warn('[rcWidget] RingCentral widget not ready -- open the widget (bottom-right) and log in first.');
    }
  } catch (err) {
    console.error('[rcWidget] clickToCall failed:', err.message);
  }
}
